<template>
  <div class="rj-page-card">
    <div class="title">
      详细信息
    </div>
    <el-table
      :data="tableData"
      border
      max-height="500"
      show-summary
      :summary-method="handleGetTotal"
    >
      <el-table-column label="序号" type="index" align="left" fixed="left" width="60" />
      <el-table-column
        prop="contractNum"
        label="合同编号"
        align="left"
        min-width="150"
        fixed="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="orderNum"
        label="订单编号"
        align="left"
        min-width="150"
        :formatter="formatterValue"
        show-overflow-tooltip
      />
      <el-table-column
        prop="orderRowNum"
        label="订单行号"
        align="left"
        min-width="120"
        sortable
        :sort-method="handleSortMethod"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="projectName"
        label="项目名称"
        align="left"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="productName"
        label="产品型号"
        sortable
        align="left"
        header-align="left"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="quantity"
        label="未发货总数量"
        align="left"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="settlementAmount"
        label="结算金额"
        align="right"
        header-align="left"
        min-width="150"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'number')"
      />
      <el-table-column
        prop="settlementAmountCny"
        label="客期变更金额（人民币）"
        align="right"
        header-align="left"
        min-width="170"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'number')"
      />
      <el-table-column
        prop="advanceFrequency"
        label="客期已提前次数"
        align="left"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="delayFrequency"
        label="客期已延迟次数"
        align="left"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="isControlled"
        label="是否受控"
        align="left"
        min-width="120"
        show-overflow-tooltip
      >
        <template v-slot="{ row }">
          <span>
            {{
              row.isControlled ? '受控' : "其他"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ceddBefore"
        label="当前客期"
        sortable
        align="left"
        min-width="110"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'date')"
      />
      <el-table-column
        prop="ceddAfter"
        label="申请变更客期"
        sortable
        align="left"
        min-width="150"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'date')"
      />
      <el-table-column
        prop="changeDays"
        label="变更天数"
        align="left"
        min-width="80"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <template v-if="isAdvance">
        <el-table-column
          prop="rectificationDeliveryDate"
          label="整改后交期"
          align="left"
          min-width="180"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />
        <el-table-column
          prop="suggestionDeliveryDate"
          label="建议交期"
          align="left"
          min-width="180"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />
        <el-table-column
          prop="isMet"
          label="是否满足交期"
          align="left"
          min-width="180"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'yesOrNo')"
        />
      </template>

      <template v-if="isDelay">
        <el-table-column
          prop="firstRectificationDeliveryDate"
          label="首次维护的整改后交期"
          align="left"
          min-width="186"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />
        <el-table-column
          prop="rectificationDeliveryDate"
          label="整改后交期"
          align="left"
          min-width="180"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />
      </template>
      <template v-if="isShowProductCoordination">
        <el-table-column
          prop="consensusDate"
          label="共识变更客期"
          align="left"
          min-width="150"
          sortable
          show-overflow-tooltip
          :formatter="(...reset) => formatterValue(...reset, 'date')"
        />
        <el-table-column
          prop="productCoordination"
          label="产品统筹"
          align="left"
          min-width="150"
          sortable
          show-overflow-tooltip
          :formatter="formatterValue"
        />
      </template>
    </el-table>
  </div>
</template>
<script>
import { deepCopy, formatterValue, getNum, numAdd } from '@/libs/util';
import Big from 'big.js';

export default {
  name: 'DetailedInformation',
  props: {
    // 变更类型
    changeType: {
      type: String,
      default: ''
    },
    // 审批单的状态
    approveStatus: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      tableData: []
    };
  },
  computed: {
    // 变更类型:提前,显示整改后交期、建议交期、是否满足交期 三列
    isAdvance () {
      return this.changeType === 'advance';
    },
    // 变更类型:延迟,显示首次维护的整改后交期、整改后交期 两列
    isDelay () {
      return this.changeType === 'delay';
    },
    // 是否显示产品统筹 完成或者是供应统筹人员
    isShowProductCoordination () {
      return (
        Number(this.approveStatus) === 30 ||
        this.$store.state.user.isSupplyCoordination
      );
    }
  },
  methods: {
    formatterValue,
    setDefaultFormData (data) {
      const { detail } = deepCopy(data);
      this.tableData = detail;
      let totalCny = 0;
      this.tableData.forEach((item) => {
        totalCny = numAdd(getNum(item.settlementAmountCny), totalCny);
      });
      this.$emit('totalCny', totalCny);
    },
    // 计算总价
    handleGetTotal (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        if (index !== 7) {
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = Big(getNum(values.reduce((prev, curr) => {
            const value = Number(curr);
            return isNaN(value) ? prev : prev + curr;
          }, 0))).toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    handleSortMethod (a, b) {
      return Big(getNum(a.orderRowNum)).minus(Big(getNum(b.orderRowNum))).toNumber();
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #383838;
  margin-bottom: 12px;
}

/deep/.el-table-column--selection > .cell {
  padding-left: 10px;
  padding-right: 10px;
}

</style>
